import { Callout, Details, Mermaid } from "../components";

export function Traction() {
  return (
    <>
      <h1>Traction</h1>

      <h2>Customers</h2>
      <p>
        TAIGA signed its first customer contracts weeks after incorporation —
        including a publicly traded enterprise organization in a regulated
        industry. EUR 10k+ MRR closing within weeks of starting operations.
        MVP deploying against real customer projects — not demos, not
        sandboxes, real work from paying customers.
      </p>
      <p>
        The pipeline is healthy and growing. Multiple beta customers across
        national security, healthcare, finance, and manufacturing — all signed
        or in advanced conversations. These are organizations that have active
        AI transformation budgets but cannot adopt current tools because nobody
        governs them. TAIGA solves that problem, and they are willing to pay
        for it today.
      </p>

      <Callout variant="success" title="The Signal">
        A pre-seed company with paying customers — including a publicly listed
        enterprise — before the round closes.
      </Callout>

      <hr />

      <h2>Development Velocity</h2>
      <p>
        The product is not vaporware. 743 commits in 2 months. Four technical
        founders, all building.
      </p>

      <table>
        <thead>
          <tr>
            <th>Metric</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Total commits</td>
            <td>~743</td>
          </tr>
          <tr>
            <td>Time period</td>
            <td>~2 months</td>
          </tr>
          <tr>
            <td>Average commits/day</td>
            <td>~12</td>
          </tr>
          <tr>
            <td>Active contributors</td>
            <td>4 (all founders)</td>
          </tr>
          <tr>
            <td>Primary language</td>
            <td>TypeScript</td>
          </tr>
        </tbody>
      </table>

      <h3>How That Compares</h3>
      <table>
        <thead>
          <tr>
            <th>Metric</th>
            <th>Typical Pre-Seed</th>
            <th>TAIGA</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Commits in first 2 months</td>
            <td>50–200</td>
            <td>~743</td>
          </tr>
          <tr>
            <td>Active technical founders</td>
            <td>1–2</td>
            <td>4</td>
          </tr>
          <tr>
            <td>Documentation</td>
            <td>Minimal</td>
            <td>Extensive (vision, PRD, architecture, security)</td>
          </tr>
          <tr>
            <td>Security documentation</td>
            <td>None</td>
            <td>Threat model, DPIA, risk register</td>
          </tr>
        </tbody>
      </table>

      <hr />

      <h2>Milestones Achieved</h2>
      <Details variant="success" title="Milestones Achieved (9)">
        <ul>
          <li>
            First customer contracts signed — including a publicly traded
            enterprise in a regulated industry
          </li>
          <li>EUR 10k+ MRR closing within weeks of incorporation</li>
          <li>
            Healthy pipeline of beta customers across defense, healthcare,
            finance, and manufacturing
          </li>
          <li>
            MVP (beta) deploying with joint pilot projects from real customer
            projects
          </li>
          <li>Angel round closed (EUR 150k)</li>
          <li>
            Non-dilutive funding secured (EUR 200k Finnvera, EUR 100k BF Sprint
            near-certain, EUR 250k BF R&D in pipeline)
          </li>
          <li>AI Agent-driven ISO 27001-compliant ISMS implemented</li>
          <li>
            Comprehensive security documentation complete (threat model, DPIA,
            risk register, 16 security policies)
          </li>
          <li>
            CI/CD pipeline with 16 GitHub Actions workflows covering build,
            test, deploy, and security scanning
          </li>
          <li>Company incorporated (March 2026)</li>
        </ul>
      </Details>

      <hr />

      <h2>Engineering Maturity</h2>
      <p>
        What TAIGA has built in 2 months is not typical for pre-seed. This is
        enterprise-grade infrastructure from day one.
      </p>

      <Details variant="info" title="CI/CD — 16 GitHub Actions Workflows">
        ESLint, Prettier, TypeScript strict mode, unit tests, Trivy container
        scanning, Checkov IaC scanning, Semgrep code analysis, automated
        deployments. Trunk-based development with PR reviews required — humans
        review AI-generated code, not vice versa.
      </Details>

      <Details variant="info" title="Infrastructure — Series B Posture at Pre-Seed">
        AWS multi-account landing zone with Control Tower. Five organizational
        units. SCPs enforcing EU-only regions, encryption, and root
        restrictions. GuardDuty, Security Hub, Inspector, Config, IAM Access
        Analyzer, and CloudTrail — all org-wide. This is the infrastructure
        posture of a Series B company.
      </Details>

      <Details
        variant="info"
        title="Documentation — A Product Feature, Not an Afterthought"
      >
        Per-project TAIGA generates: Project Specification, Technology
        Decisions, PRD, Architecture Overview, Threat Model, Data Flow Diagram,
        DPIA, Risk Register, and Backlog. All traceable, all compliant, all
        living documents. The documentation is not an afterthought — it is a
        product feature.
      </Details>

      <Details variant="info" title="Dogfooding — We Use TAIGA to Build TAIGA">
        TAIGA uses its own platform to build TAIGA. The ISMS is AI
        agent-driven. The governance workflows are the same ones customers
        will use. Every piece of internal infrastructure validates the product
        thesis in production.
      </Details>

      <hr />

      <h2>Next Milestones</h2>
      <ul>
        <li>Production-ready platform</li>
        <li>Scale pilot customer base</li>
        <li>
          First hire — full-stack AI builder to accelerate platform development
        </li>
        <li>Pre-seed close (EUR 2M)</li>
        <li>EUR 60k MRR target</li>
      </ul>

      <Mermaid
        label="Roadmap from production-ready platform through EUR 60k MRR target"
        chart={`
          graph LR
            A[Production-ready<br/>platform] --> B[Scale pilot<br/>customer base]
            B --> C[First hire<br/>AI builder]
            C --> D[Pre-seed close<br/>EUR 2M]
            D --> E[EUR 60k<br/>MRR target]
        `}
      />
    </>
  );
}
